import { Box, Flex, Pagination } from "@legion-ui/core";

interface Props {
  page: number;
  total: number;
  onChangePage: (page: number) => void;
  onChangeLimit: (limit: number) => void;
}

export function PaginationFooter({
  page,
  total,
  onChangePage,
  onChangeLimit,
}: Props) {
  return (
    <Box mt="1rem">
      <Flex alignX="flex-end">
        <Pagination
          currentPage={page}
          totalPages={total}
          options={["10", "20", "30", "50"]}
          variant="rounded"
          onClickPage={onChangePage}
          onClickOption={(opt) => onChangeLimit(Number(opt))}
        />
      </Flex>
    </Box>
  );
}
